<template>
	<div v-if="isActive || isSelected" class="list-group-item col-xs-12" :class="{ active: isSelected && isActive}">
		<div class="col-xs-12 pl-0 pr-0">
			<label class="radio-checkbox-label radio-inline col-xs-12 pr-0" @click.prevent>
				<input class="checkbox" type="radio" :checked="isSelected" />
				<span class="checkbox-custom" >
					<span v-if="isSelected && isActive" class="checkbox-dot" />
					<span v-else-if="isSelected && ! isActive" class="glyphicon glyphicon-ok ok-mark" />
				</span>
				<span style="font-weight: bold;" class="ml-3">{{ store.name }}
					<span v-if="storeDistance && isActive" class="store-distance sub-title" style="font-weight: normal;">{{ storeDistance }}</span>
					<span v-else-if="isActive" class="sub-title" style="font-weight: normal; font-size: 12px;">{{ store.city }}</span>
				</span>
				<span v-if="isActive" class="pull-right" style="font-weight: bold;">0 kr</span>
				<span v-else class="pull-right" style="font-weight: bold;">Ändra</span>
			</label>
		</div>
		<div class="col-xs-9 col-md-10 stock">
			<span :class="['stock-icon', stockClass]" />
			<p class="sub-title">
				{{ recalculateStock }}
				<span v-if="storeMessage" class="highlight">
					{{ storeMessage }}
				</span>
			</p>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import stockUtils from 'utils/stock';
import { convertToCdnUrl } from 'utils';
import { getStore } from 'datastore/i18n';
import { t } from 'datastore/i18n';

export default {
	data() {
		return {
			stockText: '',
			stockTextExtra: '',
			stockStatus: 1,
			stockClass: {
				'stock-icon-instock': true,
			},
			solna: 33,
			mos: 20,
			bredden: 31,
		};
	},
	props: {
		selectedStoreId: {
			type: Number,
			required: false,
		},
		isActive: {
			type: Boolean,
			required: true,
		},
		stock: { required: true },
		storeId: { required: true },
		cartRows: { required: true },
		storeDistance: { required: false, default: null },
	},
	methods: {
		convertToCdnUrl,
		tc: t.prefix('CHECKOUT.STOCK'),
	},
	computed: {
		recalculateStock () {
			let release = null;
			for (const row of this.cartRows) {
				const r = row.product.release;
				if (! release || r.timestamp > release.timestamp) {
					release = r;
				}
			}
			const ret = stockUtils.calculateStockStatus(this.storeId, this.stock, this.userSettings, release, 'small');

			if (ret.stockClass.hasOwnProperty('stock-icon-instock')) {
				ret.stockText = 'direkt!';
			} else {
				if (ret.stockClass.hasOwnProperty('stock-icon-outofstock-incentral')) {
					ret.stockText = 'om ' + ret.stockText;
				}
			}
			this.stockClass = ret.stockClass;

			// Remove stock message from solna & mos if CC isnt activated
			if (this.storeMessage && (this.storeId === this.solna || this.storeId === this.mos)) {
				return '';
			}


			return ret.stockText == 'Ej i lager' ? this.tc('STORE_OUT_OF_STOCK') : 'Redo att hämtas ' + ret.stockText ;
		},
		store () {
			return getStore(this.storeId);
		},
		isSelected () {
			return this.selectedStoreId === this.storeId;
		},
		storeMessage () {
			const today = new Date();
			let storeMessage = false;

			switch (this.storeId) {
				case this.bredden:
					const breddenStopCC = new Date('2025/05/15 00:00:01');
					const breddenOpen = new Date('2025/05/27 00:20:00');
					if (today > breddenStopCC && today < breddenOpen) {
						storeMessage = 'Bredden stänger tillfälligt för flytt 22 maj';
					} else if (today > breddenOpen) {
						storeMessage = 'Ny adress: Kanalvägen 3B';
					}
					break;
				default:
					break;
			}

			return storeMessage;
		},
		...mapState({
			userSettings: state => state.userSettings,
			userLevel: state =>state.user.rankLevel,
		}),
	},
};
</script>
